import { Haptics, ImpactStyle, NotificationType } from "@capacitor/haptics";
import { isNative } from "@/platform";

export const hapticTap = (): void => {
  if (!isNative()) return;
  void Haptics.impact({ style: ImpactStyle.Light });
};

/** Heavy impact — used for high-consequence confirmations (device start/stop). */
export const hapticHeavy = (): void => {
  if (!isNative()) return;
  void Haptics.impact({ style: ImpactStyle.Heavy });
};

export const hapticSuccess = (): void => {
  if (!isNative()) return;
  void Haptics.notification({ type: NotificationType.Success });
};

export const hapticWarning = (): void => {
  if (!isNative()) return;
  void Haptics.notification({ type: NotificationType.Warning });
};

export const hapticError = (): void => {
  if (!isNative()) return;
  void Haptics.notification({ type: NotificationType.Error });
};
